import {ExtraFee} from "../entities/extra-fee";
import {CustomGroup} from "../entities/custom-group";
import {Corridor} from "../entities/corridor/corridor";
import {EnumQuoteServiceSalesType} from "../enum/enum-quote-service-sales-type";

export class QuoteService {

    public code?: string;
    public contractInfoInputs?: any;
    public lastContractInfoInputs?: any;
    public appliedPrice?: string;
    public appliedPriceOnlyNegociable?: string;
    public appliedPriceOnlyNonNegociable?: string;
    public appliedPriceColor?: string;
    public appliedPriceDevices?: string;
    public appliedPriceConsumables?: string;
    public appliedPriceDevicesColor?: string;
    public appliedPriceConsumablesColor?: string;
    public distance?: string;
    public nonNegociableArticleColor?: string;
    public uniqueReferenceCoefficient?: string;
    public totalLogisticsPrice?: string;
    public factorVt?: string;
    public factorFreeMonth?: string;
    public extraFees?: ExtraFee[];
    public discount?: string;
    public isCustomGroups?: boolean;
    public customGroups?: CustomGroup[];
    public corridorConsumables?: Corridor;
    public corridorDevices?: Corridor;
    public globalCorridor?: Corridor;
    public corridorDevicesOnlyNegociable?: Corridor;
    public corridorConsumablesOnlyNegociable?: Corridor;
    public globalCorridorOnlyNegociable?: Corridor;
    public additionalStockAmount?: string;
    public userInputs?: Record<string, any>
    public devicesDiscount?: string;
    public consumablesDiscount?: string;
    public salesType: EnumQuoteServiceSalesType;

}

